module.exports = __webpack_public_path__ + "assets/img/ant-nuosavo-namo-saules-elektrine.1fdb71f4.jpg";